import { render } from "./contract-responsible-persons.vue?vue&type=template&id=a5926010"
import script from "./contract-responsible-persons.vue?vue&type=script&setup=true&lang=js"
export * from "./contract-responsible-persons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/widgets/contract-responsible-persons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5926010"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5926010', __exports__)) {
    api.reload('a5926010', __exports__)
  }
  
  module.hot.accept("./contract-responsible-persons.vue?vue&type=template&id=a5926010", () => {
    api.rerender('a5926010', render)
  })

}


export default __exports__